import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import _get from 'lodash-es/get';
import { TokenValidatorService } from '../core/services/token-validator/token-validator.service';
import { Message, MessageType, NotyService, ForgotPasswordModes } from '@dn/libs/ui/dn-common';
import notyMessage from '../core/constants/noty-messages';
import { getConstants } from '../core/constants/constants';
import { APP_CONFIG } from '../core/tokens/app-config.token';
import { Environment } from '../../environments/environment.interface';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss',
  standalone: false,
})
export class ResetPasswordComponent implements OnInit {
  forgotPasswordMode = ForgotPasswordModes.LINKED_EXPIRED_PAGE;

  email: any;
  token: string;
  queryParams;

  private readonly appConfig = inject(APP_CONFIG);

  constructor(
    private readonly router: Router,
    private readonly notyService: NotyService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly tokenValidatorService: TokenValidatorService,
  ) {}

  ngOnInit() {
    this.checkIfTokenValid();
    this.queryParams = _get(this.activatedRoute, 'snapshot.queryParams');
  }

  checkIfTokenValid() {
    const resetPasswordToken = this.activatedRoute.snapshot.paramMap.get('resetPasswordToken') || '';

    const isTokenValid = this.tokenValidatorService.isTokenValid(resetPasswordToken);
    if (!isTokenValid) {
      this.goToLogin();
      return;
    }

    const tokenValues = this.tokenValidatorService.getTokenDecodedValues(resetPasswordToken);
    if (_get(tokenValues, 'error')) {
      this.goToLogin();
      return;
    }
    this.email = _get(tokenValues, 'email', '');

    const isTokenExpired = this.tokenValidatorService.isTokenExpired(resetPasswordToken);
    if (!isTokenExpired) {
      this.token = resetPasswordToken;
      this.forgotPasswordMode = ForgotPasswordModes.RESET_PASSWORD_PAGE;
    } else {
      this.forgotPasswordMode = ForgotPasswordModes.LINKED_EXPIRED_PAGE;
    }
  }

  goToLogin() {
    this.router.navigate(['/login']);
  }

  resetPasswordResponse(resetPasswordRes) {
    const { success, errorType } = resetPasswordRes;
    if (success) {
      this.notyService.postMessage(new Message(MessageType.SUCCESS, notyMessage.RESET_PASSWORD_SUCCESS));
      this.router.navigate(['/login']);
    } else if (errorType === 'INVALID_TOKEN') {
      this.forgotPasswordMode = ForgotPasswordModes.LINKED_EXPIRED_PAGE;
    } else {
      this.goToLogin();
    }
  }

  get skipCaptcha(): boolean {
    const constants = getConstants(this.appConfig);
    return this.queryParams[constants.SKIPCAPTCHA_KEY] === 'true' && !this.appConfig.production;
  }

  resendLinkResponse(emailSentRes) {
    const { success } = emailSentRes;
    if (success) {
      this.notyService.postMessage(new Message(MessageType.SUCCESS, notyMessage.EMAIL_VERIFICATION_SENT_SUCCESS));
      this.forgotPasswordMode = ForgotPasswordModes.EMAIL_SENT_PAGE;
    } else {
      this.notyService.postMessage(new Message(MessageType.ERROR, notyMessage.EMAIL_VERIFICATION_SENT_FAILURE));
    }
  }
}
